// js
import React from 'react';
import PropTypes from 'prop-types';

const USE_ICONS = ['could', 'should', 'partial', 'full'];


const AdoptionChartIcon = ({ value }) => {

  return (
    <span
      className={`icon icon-use-${USE_ICONS[value]}`}
    />
  );
};

AdoptionChartIcon.propTypes = {
  value: PropTypes.number
};

export default AdoptionChartIcon;



// WEBPACK FOOTER //
// ./src/components/analytics/AdoptionChartIcon.js